var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "700px" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on, attrs }) {
              return [_vm._t("clickable", null, { on: on, attrs: attrs })]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "rounded-t-0" },
        [
          _c(
            "v-card-title",
            {
              staticClass: "headline mitreSecondaryBlue",
              attrs: { "data-cy": "groupModalTitle", "primary-title": "" },
            },
            [_vm._v("Group API Keys")]
          ),
          _c(
            "v-card-text",
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-row-reverse",
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.addAPIKey },
                },
                [
                  _c("span", { staticClass: "pt-1" }, [_vm._v("Add API Key")]),
                  _c("v-icon", [_vm._v("mdi-plus")]),
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "elevation-0",
                attrs: {
                  headers: _vm.apiKeyHeaders,
                  items: _vm.apiKeys,
                  "items-per-page": 5,
                  search: _vm.search,
                  loading: _vm.loading,
                  "loading-text": _vm.loadingText,
                  "no-data-text": _vm.noDataText,
                  "no-results-text": _vm.noResultsText,
                  "footer-props": {
                    "items-per-page-options": [5, 10, 25, 50, 100],
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.name`,
                      fn: function ({ item }) {
                        return [
                          _c("v-text-field", {
                            on: {
                              change: function ($event) {
                                return _vm.setKeyName(item)
                              },
                            },
                            model: {
                              value: item.name,
                              callback: function ($$v) {
                                _vm.$set(item, "name", $$v)
                              },
                              expression: "item.name",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.apiKey`,
                      fn: function ({ item }) {
                        return [
                          _c("span", { staticClass: "break-lines" }, [
                            _vm._v(
                              _vm._s(item.apiKey || "Only Shown on Creation")
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.action`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "mr-2",
                                                attrs: { small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.refreshAPIKey(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              "v-icon",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_vm._v("mdi-refresh")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Recreate this API Key")])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { right: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "mr-2",
                                                attrs: { small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteAPIKey(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              "v-icon",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_vm._v("mdi-delete")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Delete this API Key")])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "span",
                                          _vm._g(
                                            _vm._b({}, "span", attrs, false),
                                            on
                                          ),
                                          [
                                            item.apiKey
                                              ? _c("CopyButton", {
                                                  attrs: { text: item.apiKey },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Copy this API Key")])]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("v-text-field", {
                ref: "password",
                attrs: {
                  id: "password_field",
                  type: "password",
                  label: "Password",
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c(
                "v-col",
                { staticClass: "text-right" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "data-cy": "closeAndDiscardChanges",
                        color: "primary",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }